// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Roboto:ital,wght@0,100;0,300;0,400;0,500;0,700;0,900;1,100;1,300;1,400;1,500;1,700;1,900&display=swap);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Open+Sans:ital,wght@0,300..800;1,300..800&display=swap);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Inter:wght@100..900&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.header_main_container {
  width: 100%;
  height: 80px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 50px;

  background: rgba(11, 18, 20, 0.9);
  box-shadow: 14px 4px 4px 0px rgba(0, 0, 0, 0.25);
}

.header_drawer_logo_div > img {
  filter: invert(100%);
  /* height: 40px; */
  width: 260px;
}

.header_btn_list_div > ul {
  display: flex;
  align-items: center;
  flex-direction: row;
  gap: 50px;
}

.header_btn_list_li {
  color: #fff;
  font-family: "Roboto";
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
  list-style: none;
}

.header_join_btn_div {
  width: 160px;
  height: 42px;
  margin-right: 50px;
}

.header_join_btn_div > button {
  width: 203px;
  height: 46.378px;
  background: none;
  border: 1.4px solid #fff;
  color: #fff;
  text-align: center;
  font-family: "Open Sans";
  font-size: 20px;
  font-style: normal;
  font-weight: 600;
  line-height: 136.304%;
  cursor: pointer;
}

.header_menu_btn_div {
  display: none;
}

.header_menu_btn_icon {
  color: #fff;
  font-size: 40px;
}

@media screen and (max-width: 1040px) {
  .header_main_container {
    height: 80px;
    justify-content: space-between;
    padding: 0 20px;
  }

  .header_btn_list_div {
    display: none;
  }

  .header_btn_list_div > ul {
    flex-direction: row;
    gap: 71px;
  }

  .header_btn_list_li {
    font-size: 16px;
    line-height: 24px;
  }

  .header_join_btn_div {
    width: 203px;
    height: 49px;
    display: none;
  }

  .header_join_btn_div > button {
    width: 203px;
    height: 49px;
    padding: 4px 0 0 0;
    margin: -4px 0 0 -4px;
  }

  .header_menu_btn_div {
    display: block;
  }

  .header_menu_btn_icon {
    font-size: 30px;
    margin-top: 5px;
    cursor: pointer;
  }

  .header_drawer_main {
    width: 100%;
    height: 100vh;
  }

  .header_drawer_inner {
    width: 300px;
    height: 100vh;
    background-color: black;
    padding: 20px;
  }

  .header_drawer_header {
    width: 100%;
    display: flex;
    align-items: end;
    justify-content: space-between;
    flex-direction: row;
    margin-right: 10px;
  }

  .header_drawer_logo_div > img {
    filter: invert(100%);
    height: 40px;
    width: 220px;
  }

  .header_drwawer_menu_btn_icon {
    color: white;
    font-size: 35px;
    cursor: pointer;
    margin: 0 -10px 5px 0;
  }

  .header_drawer_list_div {
    width: 100%;
    margin: 50px 0 50px 0;
  }

  .header_drawer_list_div > ul {
    width: 100%;
    display: flex;
    flex-direction: column;
  }

  .header_drawer_li {
    font-size: 20px;
    line-height: 35px;
    color: #fff;
    font-family: Roboto;
    font-style: normal;
    font-weight: 400;
    list-style: none;
    cursor: pointer;
  }

  .header_drawer_join_btn_div {
    width: 160px;
    height: 42px;
    position: relative;
    margin-top: 50px;
  }

  .header_drawer_join_btn_div > button {
    border: 1px solid #fff;
    color: #fff;
    font-size: 16px;
    font-weight: 600;
    background: none;
    position: absolute;
    z-index: 2;
    width: 160px;
    height: 42px;
    padding: 4px 0 0 0;
    margin: -4px 0 0 -4px;
  }
}

@media screen and (max-width: 600px) {
  .header_main_container {
    height: 60px;
  }

  .header_drawer_inner {
    width: 300px;
    height: 100vh;
    background-color: black;
    padding: 6px 16px;
  }

  .header_drawer_logo_div > img {
    filter: invert(100%);
    margin-top: 10px;
    width: 180px;
  }

  .header_drawer_list_div {
    width: 100%;
    margin: 20px 0 30px 0;
  }

  .header_drawer_join_btn_div {
    width: 160px;
    height: 40px;
    position: relative;
  }
  
  .header_drawer_join_btn_div > button {
    border: 1px solid #fff;
    color: #fff;
    font-size: 16px;
    font-weight: 600;
    padding: 0;
    background: none;
    position: absolute;
    z-index: 2;
    width: 160px;
    height: 40px;
    padding: 5px 0 0 0;
    margin: -4px 0 0 -4px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/common/header/header.css"],"names":[],"mappings":"AAIA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;;EAEf,iCAAiC;EACjC,gDAAgD;AAClD;;AAEA;EAEE,oBAAoB;EACpB,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,qBAAqB;EACrB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,wBAAwB;EACxB,WAAW;EACX,kBAAkB;EAClB,wBAAwB;EACxB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,WAAW;EACX,eAAe;AACjB;;AAEA;EACE;IACE,YAAY;IACZ,8BAA8B;IAC9B,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,mBAAmB;IACnB,SAAS;EACX;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,YAAY;IACZ,YAAY;IACZ,aAAa;EACf;;EAEA;IACE,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,qBAAqB;EACvB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,eAAe;IACf,eAAe;IACf,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,aAAa;EACf;;EAEA;IACE,YAAY;IACZ,aAAa;IACb,uBAAuB;IACvB,aAAa;EACf;;EAEA;IACE,WAAW;IACX,aAAa;IACb,gBAAgB;IAChB,8BAA8B;IAC9B,mBAAmB;IACnB,kBAAkB;EACpB;;EAEA;IAEE,oBAAoB;IACpB,YAAY;IACZ,YAAY;EACd;;EAEA;IACE,YAAY;IACZ,eAAe;IACf,eAAe;IACf,qBAAqB;EACvB;;EAEA;IACE,WAAW;IACX,qBAAqB;EACvB;;EAEA;IACE,WAAW;IACX,aAAa;IACb,sBAAsB;EACxB;;EAEA;IACE,eAAe;IACf,iBAAiB;IACjB,WAAW;IACX,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;IAChB,gBAAgB;IAChB,eAAe;EACjB;;EAEA;IACE,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA;IACE,sBAAsB;IACtB,WAAW;IACX,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,kBAAkB;IAClB,UAAU;IACV,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,qBAAqB;EACvB;AACF;;AAEA;EACE;IACE,YAAY;EACd;;EAEA;IACE,YAAY;IACZ,aAAa;IACb,uBAAuB;IACvB,iBAAiB;EACnB;;EAEA;IAEE,oBAAoB;IACpB,gBAAgB;IAChB,YAAY;EACd;;EAEA;IACE,WAAW;IACX,qBAAqB;EACvB;;EAEA;IACE,YAAY;IACZ,YAAY;IACZ,kBAAkB;EACpB;;EAEA;IACE,sBAAsB;IACtB,WAAW;IACX,eAAe;IACf,gBAAgB;IAChB,UAAU;IACV,gBAAgB;IAChB,kBAAkB;IAClB,UAAU;IACV,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,qBAAqB;EACvB;AACF","sourcesContent":["@import url(\"https://fonts.googleapis.com/css2?family=Roboto:ital,wght@0,100;0,300;0,400;0,500;0,700;0,900;1,100;1,300;1,400;1,500;1,700;1,900&display=swap\");\n@import url(\"https://fonts.googleapis.com/css2?family=Open+Sans:ital,wght@0,300..800;1,300..800&display=swap\");\n@import url(\"https://fonts.googleapis.com/css2?family=Inter:wght@100..900&display=swap\");\n\n.header_main_container {\n  width: 100%;\n  height: 80px;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 0 50px;\n\n  background: rgba(11, 18, 20, 0.9);\n  box-shadow: 14px 4px 4px 0px rgba(0, 0, 0, 0.25);\n}\n\n.header_drawer_logo_div > img {\n  -webkit-filter: invert(100%);\n  filter: invert(100%);\n  /* height: 40px; */\n  width: 260px;\n}\n\n.header_btn_list_div > ul {\n  display: flex;\n  align-items: center;\n  flex-direction: row;\n  gap: 50px;\n}\n\n.header_btn_list_li {\n  color: #fff;\n  font-family: \"Roboto\";\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 24px;\n  list-style: none;\n}\n\n.header_join_btn_div {\n  width: 160px;\n  height: 42px;\n  margin-right: 50px;\n}\n\n.header_join_btn_div > button {\n  width: 203px;\n  height: 46.378px;\n  background: none;\n  border: 1.4px solid #fff;\n  color: #fff;\n  text-align: center;\n  font-family: \"Open Sans\";\n  font-size: 20px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: 136.304%;\n  cursor: pointer;\n}\n\n.header_menu_btn_div {\n  display: none;\n}\n\n.header_menu_btn_icon {\n  color: #fff;\n  font-size: 40px;\n}\n\n@media screen and (max-width: 1040px) {\n  .header_main_container {\n    height: 80px;\n    justify-content: space-between;\n    padding: 0 20px;\n  }\n\n  .header_btn_list_div {\n    display: none;\n  }\n\n  .header_btn_list_div > ul {\n    flex-direction: row;\n    gap: 71px;\n  }\n\n  .header_btn_list_li {\n    font-size: 16px;\n    line-height: 24px;\n  }\n\n  .header_join_btn_div {\n    width: 203px;\n    height: 49px;\n    display: none;\n  }\n\n  .header_join_btn_div > button {\n    width: 203px;\n    height: 49px;\n    padding: 4px 0 0 0;\n    margin: -4px 0 0 -4px;\n  }\n\n  .header_menu_btn_div {\n    display: block;\n  }\n\n  .header_menu_btn_icon {\n    font-size: 30px;\n    margin-top: 5px;\n    cursor: pointer;\n  }\n\n  .header_drawer_main {\n    width: 100%;\n    height: 100vh;\n  }\n\n  .header_drawer_inner {\n    width: 300px;\n    height: 100vh;\n    background-color: black;\n    padding: 20px;\n  }\n\n  .header_drawer_header {\n    width: 100%;\n    display: flex;\n    align-items: end;\n    justify-content: space-between;\n    flex-direction: row;\n    margin-right: 10px;\n  }\n\n  .header_drawer_logo_div > img {\n    -webkit-filter: invert(100%);\n    filter: invert(100%);\n    height: 40px;\n    width: 220px;\n  }\n\n  .header_drwawer_menu_btn_icon {\n    color: white;\n    font-size: 35px;\n    cursor: pointer;\n    margin: 0 -10px 5px 0;\n  }\n\n  .header_drawer_list_div {\n    width: 100%;\n    margin: 50px 0 50px 0;\n  }\n\n  .header_drawer_list_div > ul {\n    width: 100%;\n    display: flex;\n    flex-direction: column;\n  }\n\n  .header_drawer_li {\n    font-size: 20px;\n    line-height: 35px;\n    color: #fff;\n    font-family: Roboto;\n    font-style: normal;\n    font-weight: 400;\n    list-style: none;\n    cursor: pointer;\n  }\n\n  .header_drawer_join_btn_div {\n    width: 160px;\n    height: 42px;\n    position: relative;\n    margin-top: 50px;\n  }\n\n  .header_drawer_join_btn_div > button {\n    border: 1px solid #fff;\n    color: #fff;\n    font-size: 16px;\n    font-weight: 600;\n    background: none;\n    position: absolute;\n    z-index: 2;\n    width: 160px;\n    height: 42px;\n    padding: 4px 0 0 0;\n    margin: -4px 0 0 -4px;\n  }\n}\n\n@media screen and (max-width: 600px) {\n  .header_main_container {\n    height: 60px;\n  }\n\n  .header_drawer_inner {\n    width: 300px;\n    height: 100vh;\n    background-color: black;\n    padding: 6px 16px;\n  }\n\n  .header_drawer_logo_div > img {\n    -webkit-filter: invert(100%);\n    filter: invert(100%);\n    margin-top: 10px;\n    width: 180px;\n  }\n\n  .header_drawer_list_div {\n    width: 100%;\n    margin: 20px 0 30px 0;\n  }\n\n  .header_drawer_join_btn_div {\n    width: 160px;\n    height: 40px;\n    position: relative;\n  }\n  \n  .header_drawer_join_btn_div > button {\n    border: 1px solid #fff;\n    color: #fff;\n    font-size: 16px;\n    font-weight: 600;\n    padding: 0;\n    background: none;\n    position: absolute;\n    z-index: 2;\n    width: 160px;\n    height: 40px;\n    padding: 5px 0 0 0;\n    margin: -4px 0 0 -4px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
